import { render, staticRenderFns } from "./NftTransferTable.vue?vue&type=template&id=4ba4238d&scoped=true"
import script from "./NftTransferTable.vue?vue&type=script&lang=js"
export * from "./NftTransferTable.vue?vue&type=script&lang=js"
import style0 from "./NftTransferTable.vue?vue&type=style&index=0&id=4ba4238d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba4238d",
  null
  
)

export default component.exports